<!-- 预算产品模糊搜索 -->
<template>
    <div class='seach'>
        <el-autocomplete  v-model="data.productNameCn" size="small" :fetch-suggestions="querySearchAsync"
            placeholder="请输入内容" @select="handleSelect">
            <template slot-scope="{ item }">
                <div class="name">{{ item.categorySonNameCn }} <span v-if="item.categorySonNameEn">（{{ item.categorySonNameEn }}）</span></div>
            </template>
        </el-autocomplete>
    </div>
</template>

<script>
import Api from '../../../../../components/Api'
export default {
    components: {},
    props: {
        data: {
            type: Object,
            default: () => { }
        },
        state: {
            type: Number,
        },
        keys: {
            type: String,
            default: ''
        },
        //是否过滤
        isFilter:{
            type:Boolean,
            default:false
        },
        //过滤的名字
        filterName:{
            type:String,
            default:''
        }
    },
    data() {
        return {
            input1: '',
            molds: {
                '0': 10,
                '4': 64,
                '3': 133,
                '5': 75,
                '7': 410
            },
        }
    },
    computed: {},
    watch: {},
    methods: {
        querySearchAsync(queryString, cb) {
            let obj = {
                "page": 1,
                "q": {
                    "key": this.data.productName,
                    "molds": [this.molds[this.state]],
                },
                "size": 20
            }
            new Api('resource').budgetProductList(obj).then(res => {
                if (res.status == 200) {
                    if(this.isFilter) {
                        res.data.records = res.data.records.filter(n => n.categorySonNameCn != this.filterName)
                    }
                    cb(res.data.records)
                }
            })
        },
        handleSelect(item) {
            this.$set(this.data,'productNameCn',item.categorySonNameCn ? item.categorySonNameCn : item.categorySonNameEn)
        }
    },
    created() {
        
    },
    mounted() {

    },
}
</script>
<style lang='scss' scoped></style>